import { enableFlattenedSettings } from '@gonfalon/dogfood-flags/dogfood-flags';

export function isFlattenedSettingsEnabled(): boolean {
  return enableFlattenedSettings();
}
